import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router, Event } from '@angular/router';
import { ROUTES } from '../admin-sidebar/admin-sidebar.component';
import { Location } from '@angular/common';
import { LoginService } from '../../../../services/login.service';
@Component({
    selector: 'app-admin-navbar',
    templateUrl: './admin-navbar.component.html',
    styleUrls: ['./admin-navbar.component.css']
})
export class AdminNavbarComponent implements OnInit {
    public focus: any;
    public listTitles: any[];
    public location: Location;
    sidenavOpen: boolean = true;
    username: string = 'Guest User';
    constructor(location: Location, private element: ElementRef, private router: Router, private loginService: LoginService) {
        this.location = location;
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                // Show loading indicator
            }
            if (event instanceof NavigationEnd) {
                // Hide loading indicator

                if (window.innerWidth < 1200) {
                    document.body.classList.remove('g-sidenav-pinned');
                    document.body.classList.add('g-sidenav-hidden');
                    this.sidenavOpen = false;
                }
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator

                // Present error to user
                console.log(event?.error);
            }
        });
    }

    ngOnInit(): void {
        this.listTitles = ROUTES.filter((listTitle) => listTitle);
        const user = localStorage.getItem('user');
        if (user) {
            const userJson = JSON.parse(user);
            this.username = userJson.name;
        }
    }

    logout(): void {
        this.loginService.logout();
    }
    getTitle(): string {
        let titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }

        for (let item = 0; item < this.listTitles.length; item++) {
            if (this.listTitles[item].path === titlee) {
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }

    openSearch(): void {
        document.body.classList.add('g-navbar-search-showing');
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-showing');
            document.body.classList.add('g-navbar-search-show');
        }, 150);
        setTimeout(function () {
            document.body.classList.add('g-navbar-search-shown');
        }, 300);
    }
    closeSearch(): void {
        document.body.classList.remove('g-navbar-search-shown');
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-show');
            document.body.classList.add('g-navbar-search-hiding');
        }, 150);
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-hiding');
            document.body.classList.add('g-navbar-search-hidden');
        }, 300);
        setTimeout(function () {
            document.body.classList.remove('g-navbar-search-hidden');
        }, 500);
    }
    openSidebar(): void {
        if (document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-pinned');
            document.body.classList.add('g-sidenav-hidden');
            this.sidenavOpen = false;
        } else {
            document.body.classList.add('g-sidenav-pinned');
            document.body.classList.remove('g-sidenav-hidden');
            this.sidenavOpen = true;
        }
    }
    toggleSidenav(): void {
        if (document.body.classList.contains('g-sidenav-pinned')) {
            document.body.classList.remove('g-sidenav-pinned');
            document.body.classList.add('g-sidenav-hidden');
            this.sidenavOpen = false;
        } else {
            document.body.classList.add('g-sidenav-pinned');
            document.body.classList.remove('g-sidenav-hidden');
            this.sidenavOpen = true;
        }
    }
}
